import { useQuery } from '@tanstack/react-query';
import { getPublicSettings, PublicSettings } from '../services/settings';

export const usePublicSettings = () =>
  useQuery<PublicSettings>({
    queryKey: ['public-settings'],
    queryFn: getPublicSettings,
    staleTime: 5 * 60 * 1000, // 5 minutes instead of 0
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false, // Don't refetch on mount to improve performance
  });
